import React from "react"
import styled from "styled-components"
import BaseIcon from "src/components/Base/BaseIcon"

const ResourcesFilters = ({
  showTypeFilter,
  countryList,
  yearList,
  onUpdateFilter,
}) => {
  return (
    <Wrapper>
      {showTypeFilter && (
        <Filter>
          <FilterTitle>Type</FilterTitle>
          <FilterCheckboxOptions>
            <FilterCheckboxOption>
              <FilterCheckboxControl>
                <FilterCheckboxInput
                  type="checkbox"
                  defaultChecked
                  onChange={(e) => onUpdateFilter("typeVideos", e)}
                />
                <FilterCheckboxIcon name="tick" />
                <FilterCheckboxLabel>Videos</FilterCheckboxLabel>
              </FilterCheckboxControl>
            </FilterCheckboxOption>
            <FilterCheckboxOption>
              <FilterCheckboxControl>
                <FilterCheckboxInput
                  type="checkbox"
                  defaultChecked
                  onChange={(e) => onUpdateFilter("typePhotos", e)}
                />
                <FilterCheckboxIcon name="tick" />
                <FilterCheckboxLabel>Photos</FilterCheckboxLabel>
              </FilterCheckboxControl>
            </FilterCheckboxOption>
          </FilterCheckboxOptions>
        </Filter>
      )}
      <Filter>
        <FilterTitle>Country</FilterTitle>
        <FilterSelectControl>
          <FilterSelectControlOptions
            onChange={(e) => onUpdateFilter("country", e)}
          >
            <FilterSelectControlOption value="">All</FilterSelectControlOption>
            {countryList.map((country, index) => (
              <FilterSelectControlOption key={index}>
                {country}
              </FilterSelectControlOption>
            ))}
          </FilterSelectControlOptions>
        </FilterSelectControl>
      </Filter>
      <Filter>
        <FilterTitle>Year</FilterTitle>
        <FilterSelectControl>
          <FilterSelectControlOptions
            onChange={(e) => onUpdateFilter("year", e)}
          >
            <FilterSelectControlOption value="">All</FilterSelectControlOption>
            {yearList.map((year, index) => (
              <FilterSelectControlOption key={index}>
                {year}
              </FilterSelectControlOption>
            ))}
          </FilterSelectControlOptions>
        </FilterSelectControl>
      </Filter>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const Filter = styled.div`
  margin-bottom: 32px;
`

const FilterTitle = styled.h3`
  margin-bottom: 12px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.1em;
  // color: #8c9d9d;
  color: ${(p) => p.theme.color.textLight};
`

const FilterCheckboxOptions = styled.ul`
  font-size: 15px;
  color: ${(p) => p.theme.color.textLight};
`

const FilterCheckboxOption = styled.li``

const FilterCheckboxControl = styled.label`
  display: inline-block;
  padding-left: 36px;
  position: relative;
  user-select: none;
`

const FilterCheckboxInput = styled.input`
  position: absolute;
  top: 0;
  left: -9000px;
`

const FilterCheckboxIcon = styled(BaseIcon)`
  visibility: hidden;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 6px;
  left: 4px;
  z-index: 1;
  color: #fff;

  ${FilterCheckboxInput}:checked ~ & {
    visibility: visible;
  }
`

const FilterCheckboxLabel = styled.span`
  &::before {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    top: 2px;
    left: 0;
    border: 1px solid #cfdbdb;
    border-radius: 3px;

    ${FilterCheckboxInput}:checked ~ & {
      background: #a7bbbb;
      border-color: transparent;
    }
  }
`

const FilterSelectControl = styled.div`
  height: 40px;
  position: relative;
  font-size: 15px;
  line-height: 40px;
  color: ${(p) => p.theme.color.textLight};

  &::before {
    content: "";
    position: absolute;
    top: 18px;
    right: 20px;
    border: 5px solid transparent;
    border-top-color: #638c8c;
    border-bottom: none;
  }
`

const FilterSelectControlOptions = styled.select`
  appearance: none;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  border: 1px solid #cfdbdb;
  border-radius: 3px;
  color: inherit;
`

const FilterSelectControlOption = styled.option``

export default ResourcesFilters
